import SectionHeading from "./SectionHeading";

const EFFECTS = [
  { icon: "ri-drop-fill", title: "수분 충전", desc: "피부 속부터 채워지는 깊은 수분감" },
  { icon: "ri-bubble-chart-fill", title: "모공 개선", desc: "맑고 매끈한 피부결 완성" },
  { icon: "ri-sun-fill", title: "피부톤 개선", desc: "환하고 균일한 화사한 피부" },
  { icon: "ri-arrow-up-circle-fill", title: "탄력 회복", desc: "도톰하고 탱글한 동안 피부" },
];

export default function Effects() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20healthy%20glowing%20skin%20close%20up%20of%20a%20woman%20face%20with%20radiant%20luminous%20complexion%20soft%20natural%20makeup%20free%20skin%20delicate%20dewy%20texture%20soft%20dusty%20pink%20and%20cream%20background%20editorial%20beauty%20photography%20bright%20airy%20aesthetic&width=800&height=800&seq=bianca-effect-1&orientation=landscape"
            alt="비앙카 피부관리 효과 - 빛나는 건강한 피부"
            title="비앙카 피부관리 효과"
            className="w-full h-auto object-cover object-top rounded-3xl"
          />
          <div className="absolute -bottom-6 -right-4 md:-right-6 bg-white rounded-2xl px-6 py-4 flex items-center gap-3 border border-background-200/70">
            <span className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-heart-3-fill text-primary-500 text-xl"></i>
            </span>
            <div className="flex flex-col">
              <span className="text-lg font-bold text-foreground-900">98%</span>
              <span className="text-xs text-foreground-500">관리 만족도</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-8">
          <SectionHeading
            eyebrow="Effects"
            title="관리 후 달라지는 피부"
            align="left"
            description="비앙카의 체계적인 관리로 고객님의 피부가 건강하게 변화합니다."
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {EFFECTS.map((effect) => (
              <div
                key={effect.title}
                className="flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70"
              >
                <span className="w-11 h-11 rounded-full bg-secondary-100 flex items-center justify-center shrink-0">
                  <i className={`${effect.icon} text-xl text-secondary-700`}></i>
                </span>
                <div className="flex flex-col gap-1">
                  <h3 className="text-base font-semibold text-foreground-900">{effect.title}</h3>
                  <p className="text-sm text-foreground-600">{effect.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}